import React, { useState, useEffect } from 'react'
import { API_URL } from '../Constants';
import PendingPayment from './PendingPayment';
import TestLinks from './TestLinks';
//TODO Put a refersh status button for PayPal IPN status

const fetchBillings = async (token) => {

  const res = await fetch(`${API_URL}/api/finance/billing`,
  { headers: { Authorization: `Token ${token}` } });
  try {
      const result = await res.json();
      const billings = result;
      return billings
  } catch (e) {
      console.log(e);
      console.log(res);
  }
}

const fetchPendingPayments = async (token) => {

  const res = await fetch(`${API_URL}/api/finance/pendingpayment`,
  { headers: { Authorization: `Token ${token}` } });
  try {
      const result = await res.json();
      const pendingpayments = result;
      return pendingpayments
  } catch (e) {
      console.log(e);
      console.log(res);
  }
}

const fetchProfile = async (token) => {

    const resp = await fetch(`${API_URL}/api/profile/`, {
        method: 'GET',
        headers: { Authorization: `Token ${token}` } ,
    })
      if (resp.status!==200){
          return null
      }
      try {
        const result = await resp.json();
        console.log(result);  
        return result[0];
    } catch (e) {
        console.log(e);
        console.log(resp);
    }
  }


export default function BuySubscription(props) {

  const [state, setState] = useState({});
  const [pendingpayments, setPendingpayments] = useState([]);
  
  const {token, onLogout} = props;
  const {billings,profile,discount_code,isReady} = state;
  
  useEffect(() => {
    async function init() {
      try {
        const pendingpayments = await fetchPendingPayments(token);
        setPendingpayments(pendingpayments)
      } catch (error) {}
    }
    init();
    
  },[token])

  useEffect(() => {
    async function init() {
      try {
        const billings = await fetchBillings(token);
        const profile = await fetchProfile(token);
        if (profile===null){
          onLogout();
        }
        console.log(profile);
        setState({billings,profile,isReady:true})
      } catch (error) {}
    }
    init();
    
  },[pendingpayments,token,onLogout])

  const applyDiscount = async({billing_ind,discount_code}) =>{
    const res = await fetch(`${API_URL}/api/finance/checkdiscount/${billings[billing_ind].id}/${discount_code}`,
    { method: 'GET',
    headers: { Authorization: `Token ${token}`, "Content-Type": "application/json" }
   });
   try {
    const result = await res.json();
    console.log(result);
    if (result.length>0){
      const {discount,amount} = result[0];
      const billings = [...state.billings];
      billings[billing_ind].discount = discount;
      billings[billing_ind].price = amount;
      setState({...state,billings})
    }
    } catch (e) {
        console.log(e);
        console.log(res);
    }
  }

  const buy = async (data) =>{
    console.log(data);
    const res = await fetch(`${API_URL}/api/finance/pendingpayment`,
    { method: 'POST',
    body: JSON.stringify(data),
    headers: { Authorization: `Token ${token}`, "Content-Type": "application/json" }
   });
    try {
        const pendingpayments = await fetchPendingPayments(token);
        setPendingpayments(pendingpayments);
    } catch (e) {
        console.log(e);
        console.log(res);
    }
  }

  const getBilling = (pp)=>billings.filter(b=>b.id===pp.billing)[0];


  const onPendingPaymentStatusChange = (pendingpayment) =>{
    let newpendingpayments = pendingpayments.filter(pp=>pp.id!==pendingpayment.id);
    newpendingpayments.push(pendingpayment);
    setPendingpayments(newpendingpayments)
  } 
  
  const prettyPrice = (price, currency) => {
    if (currency=== 'IRR'){
      return Number(price).toFixed(0);
    }else{
      return price;
    }
  }

  if (!isReady){
    return <></>
  }
  const paid_pp = (pendingpayments || []).filter(pp=>pp.status === 'paid');
  const unpaid_pp = (pendingpayments || []).filter(pp=>pp.status !== 'paid');
  const wating_or_pending_pp = (pendingpayments || []).filter(pp=>pp.status === 'pending' || ~pp.status.indexOf('waiting'));
  console.log(profile);
  console.log(profile?.usersubscription?.is_paidtillfuture);


  return (
    <>
      <main className='pb-5'>
      {profile?.usersubscription?.is_paidtillfuture===true && <div className='pt-5 fw-bold text-center'><div className='pb-5'>Your current subscription ends by <span className="btn fw-bold text-white bg-warning">{new Date(profile.usersubscription.paidtill).toLocaleDateString("en-US",{year: 'numeric', month: 'long', day: 'numeric'})}</span></div><TestLinks></TestLinks></div>}
        {profile?.usersubscription?.is_paidtillfuture!==true && wating_or_pending_pp.length===0 && billings!==undefined && <div className="row row-cols-1 row-cols-md-3 mb-3 text-center px-5 pt-5">
          {billings.map((b,billing_ind)=>
          <div key={`billing-${billing_ind}`} className="col">
            <div className={`card mb-4 rounded-3 shadow-sm ${b.is_highlighted ?'border-primary':''}`}>
              <div className={`card-header py-3 ${b.is_highlighted ?'text-white border-primary bg-primary':''}`}>
                <h4 className="my-0 fw-normal">{b.title}</h4>
              </div>
              <div className="card-body">
                <h1 className="card-title pricing-card-title">{prettyPrice(b.price,b.currency)} {b.currency}<small className="text-muted fw-light">/{b.human_readable_billing_cycle_abbr}</small></h1>
                {b.discount && b.discount!=='0.00' && <h2>Discount:{prettyPrice(b.discount,b.currency)}</h2>}
                <div className='row g-2 pb-2 pt-1'>
                  <div className='col-8'><input placeholder='Disount Code' className='w-100 form-control' onChange={(e)=>{setState({...state,discount_code:e.target.value})}}/></div>
                  <div className='col-4'>
                    <button className='w-100 btn btn-warning btn-sm fw-bold h-100' type='button' onClick={()=>applyDiscount({billing_ind,discount_code})}>Apply</button>
                  </div>
                </div>
                <button type="button" className="w-100 btn btn-lg btn-primary" onClick={()=>{buy({discount_code,billing:b})}}>Buy Now</button>
              </div>
            </div>
          </div>)}
        </div>}
        {unpaid_pp?.length>0 &&<div className='px-5 pt-5'>
            {unpaid_pp.map(pp=>
            <PendingPayment key={`pp-${pp.id}`} billing={getBilling(pp)} pendingpayment={pp} onPendingPaymentStatusChange={onPendingPaymentStatusChange}></PendingPayment>)}
        </div>}
        {paid_pp?.length>0 && <div className='px-5 pt-5'>
          <h2>Paid Invoices</h2>
            {paid_pp.map(pp=>
            <PendingPayment key={`pp-${pp.id}`} billing={getBilling(pp)} pendingpayment={pp}onPendingPaymentStatusChange={onPendingPaymentStatusChange}></PendingPayment>)}
        </div>}
      </main>
    </>
  )
}
